let swipersInitialized = false;

var hooxSliderCentered = document.querySelectorAll('.hoox-swiper-center');

if (!!hooxSliderCentered.length) {
    hooxSliderCentered = Array.from(hooxSliderCentered);

    const firstSwiperEl = hooxSliderCentered[0];

    const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
            if (entry.isIntersecting && !swipersInitialized) {
                // Init ALL swipers on the page
                console.log('[INTERACTION] Hoox Slider - Initialized all');

                hooxSliderCentered.forEach(element => {
                    var slides = element.querySelectorAll('.swiper-slide');

                    var swiperOptions = {
                        loop: true,
                        lazy: {
                            loadPrevNext: true,   // optional: load nearby slides in advance
                            loadOnTransitionStart: true,  // load immediately on transition
                        },            
                        slidesPerView: 1,
                        centeredSlides: true,
                        spaceBetween: 10,
                        pagination: {
                            el: '.hoox-swiper-center__pagination',
                            clickable: true
                        },
                        navigation: {
                            nextEl: '.slider-centered-next',
                            prevEl: '.slider-centered-prev',
                        },
                    };

                    if (window.innerWidth < 767 && slides.length > 1) { // Initialize on mobile with more than 1 slide
                        new Swiper(element, swiperOptions);
                    } else if (window.innerWidth > 767 && slides.length > 3) { // Initialize on desktop with more than 3 slides
                        swiperOptions.breakpoints = {
                            766: {
                                slidesPerView: 3,
                                slidesPerGroup: 1,
                                touchRatio: 0,
                            }
                        };
                        new Swiper(element, swiperOptions );
                    } else { // Hide navigation arrows if Swiper is not initialized
                        var navigation = element.querySelectorAll('.hoox-ugc-videos__navigation');
                        navigation.forEach(navItem => {
                            navItem.style.display = 'none';
                            navItem.style.margin = '0';
                        });
                    }
                });

                swipersInitialized = true;
                obs.unobserve(firstSwiperEl); // no need to observe anymore

                console.log('[INTERACTION] Hoox Slider Interaction Observer - Unobserved');
            }
        });
    }, { threshold: 0.2 }); // 20% visible triggers init

    observer.observe(firstSwiperEl);
}